import {
  Breakpoints,
  styled,
  TextTag,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import {Header} from '../../types/header';
import {Text} from '@volkswagen-onehub/components-core';
import { ContainerMain } from '../../styles/global.style';

interface HeaderInterface {
  title: Header['title'];
  descriptions?: Header['descriptions'];
  image: Header['image'];
  imagePaddingLeft?: string;
}

const HeaderBackground = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.background.primary};
  padding: ${(props) => props.theme.size.dynamic0150} 0 ${(props) => props.theme.size.dynamic0270};
`;

const HeaderContainer = styled(ContainerMain)<{$paddingLeft?: string}>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: ${Breakpoints.b960}px) {
    flex-direction: row;
  }
`;

const ImageHeaderContainer = styled.div`
  flex: 1;
  align-self: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${(props) => props.theme.size.borderRadius.imageL};
  }
`;

const TitleHeaderContainer = styled.div`
  flex: 1;
  padding: ${(props) => props.theme.size.dynamic0150};
  padding-left: ${(props) => props.theme.size.grid001};
  padding-right: ${(props) => props.theme.size.grid001};
  display: flex;
  gap: ${(props) => props.theme.size.dynamic0100};
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: ${Breakpoints.b960}px) {
    padding: ${(props) => props.theme.size.dynamic0150};
    padding-left: 0;
    padding-right: 0;
  }
`;

const Header: React.FC<HeaderInterface> = ({title, descriptions, image, imagePaddingLeft}) => {
  return (
    <HeaderBackground>
      <HeaderContainer $paddingLeft={imagePaddingLeft}>
        <ImageHeaderContainer>
          <img src={image.url} alt={image.alt} />
        </ImageHeaderContainer>
        <TitleHeaderContainer>
          <Text
            tag={TextTag.h1}
            appearance={TokenTextAppearance.headline500}
            bold
          >
            {title}
          </Text>
          {descriptions ? <Text>{descriptions}</Text> : null}
        </TitleHeaderContainer>
      </HeaderContainer>
    </HeaderBackground>
  );
};

export default Header;
